import DialogModal from "./DialogModal";
import DialogModalInputs from "./DialogModalInputs";
import DialogModalWithSteps from "./DialogModalWithSteps";

export { DialogModalInputs, DialogModalWithSteps };

export default DialogModal;
